import axios from 'axios';

const hostname = window.location.hostname;

let COMPANY_ID = 1;
let API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8001';

if (hostname.includes('carmanager')) {
  API_BASE_URL = 'https://api.carmanager.com.br';
}

if (hostname === 'localhost' || hostname === '127.0.0.1' || hostname.startsWith('127.')) {
  COMPANY_ID = 1
}


if (hostname.includes('gestao')) {
  COMPANY_ID = 1

}
if (hostname.includes('jfcars')) {
  COMPANY_ID = 2
}

if (hostname.includes('rmotors')) {
  COMPANY_ID = 3
}
const api = axios.create({
  baseURL: `${API_BASE_URL}/api/`,
  headers: {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    'company-x': COMPANY_ID
  },

});

// Interceptors para tratamento de erros
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      /* Setando erros manualmente para telas padronizadas*/
      const isLoginCall = String(error.config?.url || '').replace(/^\//, '') === 'login';
      if (error.response.status === 401 && !isLoginCall && localStorage.getItem('token')) {
        // Token expirado ou revogado: limpa a sessão e volta para o login.
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        alert('Sessão expirada. Por favor, faça login novamente.');
        window.location.href = '/login';
      } else if (error.request.status === 403 && error.request.erro == 'Banco expirado') {
        alert('Entre em contato com o suporte.');
        window.location.href = '/login';
      }
      else if (error.request.status === 403 && error.response.data.message == 'Acesso nao autorizado.') {
        window.location.href = '/acesso-negado';
      }

    }
    return Promise.reject(error);
  }
);


export default api; 